<template>
  <div class="app">
    <Header />
    <Content />
    <Footer />
    <BackToTop transitionName="fade" :visibilityHeight="300" :backPosition="0" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Header from "@/components/Header.vue";
import Content from "@/components/Content.vue";
import Footer from "@/components/Footer.vue";
import BackToTop from "@/components/BackToTop.vue";
import "@/assets/global.scss";
import "element-plus/lib/theme-chalk/display.css";

export default defineComponent({
  name: "App",
  components: {
    Header,
    Content,
    Footer,
    BackToTop
  },
  setup() {
    return {};
  }
});
</script>


<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
